import type { Entity } from '@backstage/catalog-model';

/*
 * TechDocs on an entity is not only `techdocs-ref` — a Component can point at
 * docs living in its parent repo instead of building its own, via
 * `techdocs-entity` (+ `techdocs-entity-path`); see "Where TechDocs Live" in
 * `onboarding-a-repository.md`.
 */
const TECHDOCS_REF_ANNOTATION = 'backstage.io/techdocs-ref';
const TECHDOCS_ENTITY_ANNOTATION = 'backstage.io/techdocs-entity';

/** Whether an entity's TechDocs tab has something to show. */
export function hasTechDocs(entity: Entity): boolean {
  const annotations = entity.metadata.annotations ?? {};
  return Boolean(
    annotations[TECHDOCS_REF_ANNOTATION] ??
      annotations[TECHDOCS_ENTITY_ANNOTATION],
  );
}
